import React from 'react';
import './styles/Anmeldung.css';
import {Link} from 'react-router-dom';

function AnmeldungFail() {
  return (
    <div className='anmeldungContainer'>
        <div className='anmeldungContentContainer'>
            <div className='anmeldungTextContainer'>
                <h1>Hier ist etwas schief gegangen...</h1>
                <p>Bitte wenden Sie sich mit Ihrer Anmeldung an: <a href='mailto:zeltlager@schreberjugend-suedwest.de'>zeltlager@schreberjugend-suedwest.de</a></p>
                <Link to='/'>Zur Startseite</Link>
            </div>
        </div>
        <div className='bottomContainer'>
                <Link to='https://deutsche-schreberjugend.de/'>
                    <p> Deutsche Schreberjugend</p>
                </Link>
                <Link to={'/impressum'}>
                    <p>Impressum</p>
                </Link>
                <Link to={'/datenschutz'}>
                    <p>Datensschutz</p>
                </Link>
            </div>
    </div>
  )
}

export default AnmeldungFail